__turbopack_context__.v({
  "accordionSlideOverwrite": "baseDialog-module-scss-module__cKKoqa__accordionSlideOverwrite",
  "dialogClose": "baseDialog-module-scss-module__cKKoqa__dialogClose",
  "dialogContent": "baseDialog-module-scss-module__cKKoqa__dialogContent",
  "dialogDescription": "baseDialog-module-scss-module__cKKoqa__dialogDescription",
  "dialogDetails": "baseDialog-module-scss-module__cKKoqa__dialogDetails",
  "dialogFooter": "baseDialog-module-scss-module__cKKoqa__dialogFooter",
  "dialogHeader": "baseDialog-module-scss-module__cKKoqa__dialogHeader",
  "dialogOverlay": "baseDialog-module-scss-module__cKKoqa__dialogOverlay",
  "dialogTitle": "baseDialog-module-scss-module__cKKoqa__dialogTitle",
  "fadeIn": "baseDialog-module-scss-module__cKKoqa__fadeIn",
  "fadeOut": "baseDialog-module-scss-module__cKKoqa__fadeOut",
  "scaleIn": "baseDialog-module-scss-module__cKKoqa__scaleIn",
  "scaleOut": "baseDialog-module-scss-module__cKKoqa__scaleOut",
  "zoomIn": "baseDialog-module-scss-module__cKKoqa__zoomIn",
  "zoomOut": "baseDialog-module-scss-module__cKKoqa__zoomOut",
});
